// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+XeZA","titleWrapper":"styles_titleWrapper__Gw8nA","title":"styles_title__nT25b","games":"styles_games__YOgcy","notFound":"styles_notFound__Ea2sQ"};